import { render } from "./Add.vue?vue&type=template&id=1d63ad77&scoped=true"
import script from "./Add.vue?vue&type=script&lang=js"
export * from "./Add.vue?vue&type=script&lang=js"

import "./Add.vue?vue&type=style&index=0&id=1d63ad77&scoped=true&lang=css"

import exportComponent from "/build/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d63ad77"]])

export default __exports__